export enum PartnerLayout {
  DEFAULT = 'DEFAULT',
  LAYOUT_1 = 'LAYOUT_1',
  LAYOUT_2 = 'LAYOUT_2',
  LAYOUT_3 = 'LAYOUT_3',
}

export enum PartnerOrganization {
  // Mirror
  HELIX = 'helix',
  HELIX_CONE = 'helix-cone',
  HELIX_HEALTH_PARTNERS = 'helix-health-partners',
  HELIX_LCMC = 'helix-lcmc',
  HELIX_MEMORIAL_HERMANN = 'helix-mhhs',
  HELIX_MYRTLE = 'helix-myrtle',
  HELIX_MUSC = 'helix-musc',
  HELIX_NEBRASKA = 'helix-nebraska',
  HELIX_RENOWN = 'helix-renown',
  HELIX_SANFORD = 'helix-sanford',
  HELIX_ST_LUKE = 'helix-sluhn',
  HELIX_WELLSPAN = 'helix-wellspan',
  HELIX_OSUWMC = 'helix-osuwmc',
  HELIX_WAKEMED = 'helix-wakemed',
  HELIX_TRIHEALTH = 'helix-trihealth',
  HELIX_PARKVIEW = 'helix-parkview',
  HELIX_ROCHESTER = 'helix-rochester',
  HELIX_UHN = 'helix-uhn',
  // Partner apps
  CONE = 'cone',
  HEALTH_PARTNERS = 'health-partners',
  LCMC = 'lcmc',
  MEMORIAL_HERMANN = 'mhhs',
  MYRTLE = 'myrtle',
  MUSC = 'musc',
  NEBRASKA = 'nebraska',
  RENOWN = 'renown',
  SANFORD = 'sanford',
  ST_LUKE = 'sluhn',
  WELLSPAN = 'wellspan',
  OSUWMC = 'osuwmc',
  WAKEMED = 'wakemed',
  TRIHEALTH = 'trihealth',
  PARKVIEW = 'parkview',
  ROCHESTER = 'rochester',
  UHN = 'uhn',
  BUILDER_SVC_TEST = 'builder-svc-test',
}
